document.addEventListener("DOMContentLoaded", function() {
   function ingredientAccordion() {
      var accordionSections = document.querySelectorAll(".product-accordion-item");
      accordionSections.forEach(section => {
         var accordionItemHeaders = section.querySelector(".product-accordion-item-header"),
            accordionItemBody = section.querySelector(".product-accordion-item-body");
         accordionItemHeaders.addEventListener("click", function() {
            var currentlyActiveHeader = document.querySelector(".product-accordion-item-header.active"),
               currentlyActiveBody = currentlyActiveHeader ? currentlyActiveHeader.nextElementSibling : null;
                currentlyActiveHeader && currentlyActiveBody && (currentlyActiveHeader.classList.remove("active"), currentlyActiveBody.style.maxHeight = 0), accordionItemHeaders !== currentlyActiveHeader ? (accordionItemHeaders.classList.add("active"), accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px") : (accordionItemHeaders.classList.remove("active"), accordionItemBody.style.maxHeight = 0)
         })
      })
   }
   ingredientAccordion()
});


document.addEventListener("DOMContentLoaded", function() {
   function ingredientAccordion() {
      var accordionSections = document.querySelectorAll(".ingredient-accordion-item");
      accordionSections.forEach(section => {
         var accordionItemHeaders = section.querySelector(".ingredient-accordion-item-header"),
            accordionItemBody = section.querySelector(".ingredient-accordion-item-body");
         accordionItemHeaders.addEventListener("click", function() {
            var currentlyActiveHeader = document.querySelector(".ingredient-accordion-item-header.active"),
               currentlyActiveBody = currentlyActiveHeader ? currentlyActiveHeader.nextElementSibling : null;
                currentlyActiveHeader && currentlyActiveBody && (currentlyActiveHeader.classList.remove("active"), currentlyActiveBody.style.maxHeight = 0), accordionItemHeaders !== currentlyActiveHeader ? (accordionItemHeaders.classList.add("active"), accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px") : (accordionItemHeaders.classList.remove("active"), accordionItemBody.style.maxHeight = 0)
         })
      })
   }
   ingredientAccordion()
});


document.addEventListener("DOMContentLoaded", function() {
   function footerAccordion() {
      var accordionSections = document.querySelectorAll(".footerMenu");
      accordionSections.forEach(section => {
         var accordionItemHeaders = section.querySelector(".footerMenu-head"),
             accordionItemBody = section.querySelector(".footerMenu-links");
         accordionItemHeaders.addEventListener("click", function() {
            var currentlyActiveHeader = document.querySelector(".footerMenu-head.active"),
                currentlyActiveBody = currentlyActiveHeader ? currentlyActiveHeader.nextElementSibling : null;
                currentlyActiveHeader && currentlyActiveBody && (currentlyActiveHeader.classList.remove("active"), currentlyActiveBody.style.maxHeight = 0), accordionItemHeaders !== currentlyActiveHeader ? (accordionItemHeaders.classList.add("active"), accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px") : (accordionItemHeaders.classList.remove("active"), accordionItemBody.style.maxHeight = 0)
         })
      })
   }
   footerAccordion()
});


document.addEventListener("DOMContentLoaded", function() {
   function ingredientAccordion() {
      var accordionSections = document.querySelectorAll(".faqs-accordion-item");
      accordionSections.forEach(section => {
         var accordionItemHeaders = section.querySelector(".faqs-accordion-item-header"),
            accordionItemBody = section.querySelector(".faqs-accordion-item-body");
         accordionItemHeaders.addEventListener("click", function() {
            var currentlyActiveHeader = document.querySelector(".faqs-accordion-item-header.active"),
               currentlyActiveBody = currentlyActiveHeader ? currentlyActiveHeader.nextElementSibling : null;
                currentlyActiveHeader && currentlyActiveBody && (currentlyActiveHeader.classList.remove("active"), currentlyActiveBody.style.maxHeight = 0), accordionItemHeaders !== currentlyActiveHeader ? (accordionItemHeaders.classList.add("active"), accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px") : (accordionItemHeaders.classList.remove("active"), accordionItemBody.style.maxHeight = 0)
         })
      })
   }
   ingredientAccordion()
});


